(function () {
  "use strict";

  // Helper function to get or store original margin and calculate new margin
  function getOriginalMarginAndCalculate(element, percentage) {
    // Check if we've already stored the original margin
    let originalMargin = element.dataset.klaviyoOriginalMargin;

    if (!originalMargin) {
      // Get the original computed margin-bottom before any modifications
      const computedStyle = window.getComputedStyle(element);
      originalMargin = computedStyle.marginBottom;

      // Store it for future calculations
      element.dataset.klaviyoOriginalMargin = originalMargin;
    }

    // Parse the margin value (handles px, em, rem, etc.)
    const marginMatch = originalMargin.match(/^([\d.]+)(\w+)$/);
    if (!marginMatch) {
      // If we can't parse it, return the original
      return originalMargin;
    }

    const originalValue = parseFloat(marginMatch[1]);
    const unit = marginMatch[2];

    // Calculate new margin: original * (percentage / 100)
    const newValue = originalValue * (percentage / 100);

    return newValue + unit;
  }

  // Function to apply Klaviyo reviews styling
  function applyKlaviyoReviewsStyling(settings) {
    if (!settings) {
      console.warn("Klaviyo reviews settings not found");
      return;
    }

    // Apply review item bottom margin
    if (settings.reviewItemMb !== undefined) {
      const reviewItems = document.querySelectorAll(
        '.kl_reviews__review_item, [class*="kl_reviews__review"]'
      );
      reviewItems.forEach(function (item) {
        item.style.marginBottom = getOriginalMarginAndCalculate(
          item,
          settings.reviewItemMb
        );
      });
    }

    // Apply filter bottom margin
    if (settings.filterMb !== undefined) {
      const filters = document.querySelectorAll(
        '.kl_reviews__filters, .kl_reviews__filters__pill, [class*="kl_reviews__filter"]'
      );
      filters.forEach(function (filter) {
        filter.style.marginBottom = getOriginalMarginAndCalculate(
          filter,
          settings.filterMb
        );
      });
    }

    // Apply rating summary bottom margin
    if (settings.ratingMb !== undefined) {
      const ratingSummary = document.querySelectorAll(
        '.kl_reviews__summary, .kl_reviews__summary__rating, [class*="kl_reviews__summary"]'
      );
      ratingSummary.forEach(function (summary) {
        summary.style.marginBottom = getOriginalMarginAndCalculate(
          summary,
          settings.ratingMb
        );
      });
    }
  }

  // Initialize when DOM is ready
  function init() {
    // Get settings from window.theme.klaviyoReviewsSettings if available
    if (window.theme && window.theme.klaviyoReviewsSettings) {
      applyKlaviyoReviewsStyling(window.theme.klaviyoReviewsSettings);
    }

    // Also watch for dynamically loaded Klaviyo content
    if (window.MutationObserver) {
      const observer = new MutationObserver(function (mutations) {
        if (window.theme && window.theme.klaviyoReviewsSettings) {
          applyKlaviyoReviewsStyling(window.theme.klaviyoReviewsSettings);
        }
      });

      // Start observing when body is available
      if (document.body) {
        observer.observe(document.body, {
          childList: true,
          subtree: true,
        });
      } else {
        document.addEventListener("DOMContentLoaded", function () {
          observer.observe(document.body, {
            childList: true,
            subtree: true,
          });
        });
      }
    }
  }

  // Run on DOMContentLoaded or immediately if already loaded
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
